import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Capitalize } from '../../utils/TextTransform';

const PageInfoNavHeader = props => {
    const { emoji, pageName, navList, activeNav, handleActiveNav, children } = props;
    const { isToggled } = useSelector(({ Util }) => Util);
    const history = useHistory();
    const location = useLocation();

    const handleNavigation = (path) => {
        if (path) {
            // Get current URL parameters
            const currentParams = new URLSearchParams(location.search);
            const startDate = currentParams.get('startDate');
            const endDate = currentParams.get('endDate');

            // If we have date parameters and we're navigating to payouts, preserve them
            if (startDate && endDate && path === '/payouts') {
                history.push(`${path}?startDate=${startDate}&endDate=${endDate}`);
            } else {
                history.push(path);
            }
        }
    };

    return (
        <div className={`${!isToggled ? 'oi-table-header--mod' : ''} oi-table-header`}>
            <div className="oi-screen__resizeMax1558">
                <h2 className="oi-table-header__length u-half-gradient-bg u-myb-22_5">{`${emoji} ${pageName}`}</h2>
                <div className="oi-table-header__view">
                    <nav className="oi-pageinfonav__nav u-mxl-2">
                        <ul className="oi-pageinfonav__nav-container">
                            {navList.map((element, idx) => {
                                return (
                                    <React.Fragment key={idx}>
                                        <li
                                            className={`${
                                                activeNav === element['name'] ? 'active active--lite' : ''
                                            } oi-pageinfonav__nav-list`}
                                            onClick={() => {
                                                handleActiveNav(element['name']);
                                                handleNavigation(element['path']);
                                            }}>
                                            {Capitalize(element['name'])}
                                        </li>
                                        {idx === 0 && (
                                            <span className="oi-pageinfonav__nav-arrow oi-pageinfonav__nav-list">
                                                ➞
                                            </span>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </ul>
                    </nav>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default PageInfoNavHeader;